import { Button, Tabs } from "antd";
import NotificationForm from "./components/Notification-Form/NotificationForm";
import NotificationsTable from "./components/Notifications-Table/NotificationsTable";
import { PlusCircleOutlined, NotificationOutlined } from "@ant-design/icons";
import GeneralTableHeader from "../common/general-table-header/GeneralTableHeader";
import BannersTable from "../banners/components/Banners-Table/BannersTable";
import BannerEditorModal from "../banners/components/Banner-Editor-Modal/BannerEditorModal";
import { IBannerObject } from "../../interfaces/banner.interface";

import styles from "./Notifications.module.css";
import { useState } from "react";

export default function Notifications() {
  const [activeTab, setActiveTab] = useState<"push" | "banners">("push");
  const [showForm, setShowForm] = useState(false);

  const [bannerEditorOpen, setBannerEditorOpen] = useState(false);
  const [editingBanner, setEditingBanner] = useState<IBannerObject | null>(
    null
  );
  const [bannersRefreshToggle, setBannersRefreshToggle] = useState(0);

  const openCreateBanner = () => {
    setEditingBanner(null);
    setBannerEditorOpen(true);
  };
  const openEditBanner = (banner: IBannerObject) => {
    setEditingBanner(banner);
    setBannerEditorOpen(true);
  };
  const handleBannerSaved = () => setBannersRefreshToggle((v) => v + 1);

  return (
    <div>
      <GeneralTableHeader
        title="Notifications"
        description="Send push notifications and manage Merchant Hub banners."
        avatarUrl={<NotificationOutlined style={{ fontSize: "30px" }} />}
      />
      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key as "push" | "banners")}
        tabBarExtraContent={
          activeTab === "push" ? (
            <Button
              type="primary"
              onClick={() => setShowForm(true)}
              icon={<PlusCircleOutlined />}
            >
              Schedule
            </Button>
          ) : (
            <Button
              type="primary"
              onClick={openCreateBanner}
              icon={<PlusCircleOutlined />}
            >
              Create New
            </Button>
          )
        }
        items={[
          {
            key: "push",
            label: "Push Notifications",
            children: (
              <>
                <NotificationsTable />
                <NotificationForm visible={showForm} setVisible={setShowForm} />
              </>
            ),
          },
          {
            key: "banners",
            label: "Merchant Hub Banners",
            children: (
              <>
                <div key={bannersRefreshToggle}>
                  <BannersTable onEdit={openEditBanner} />
                </div>
                <BannerEditorModal
                  open={bannerEditorOpen}
                  onClose={() => setBannerEditorOpen(false)}
                  banner={editingBanner}
                  onSaved={handleBannerSaved}
                />
              </>
            ),
          },
        ]}
      />
    </div>
  );
}
